import React from 'react';
import { Spinner } from 'react-bootstrap';
import GLOBAL_STYLES from '../styles';


const LoadingOverlay = ({ message }) => {
  return (
    <div style={styles.overlay}>
      <Spinner animation="border" />
      <p style={styles.message}>{message}</p>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 1000,
    opacity: 0.8,
    backgroundColor: GLOBAL_STYLES.CONSTANTS.black,
    color: GLOBAL_STYLES.CONSTANTS.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  message: {
    marginTop: 10,
    fontSize: 30,
  },
};

export default LoadingOverlay;
